module.exports = __webpack_public_path__ + "assets/icon-development.543b9ab5.svg";